import {useEffect} from 'react';
import Loading from '~/components/Loading';
import useHospitalInfo from '~/hooks/useHospitalInfo';
import {BookingView} from '~/modules/booking/types';
import {getSubDomain} from '~/utils';

interface TransitionViewProps {
  setActiveView: (view: BookingView) => void;
}

function TransitionView(props: TransitionViewProps) {
  const subdomain = getSubDomain();
  const {setActiveView} = props;

  const {hospitalInfo, isLoading} = useHospitalInfo();

  useEffect(() => {
    const timeout = setTimeout(() => {
      setActiveView(BookingView.AppointmentSelectionView);
    }, 5000);

    return () => clearTimeout(timeout);
  }, [setActiveView]);

  const navigateScreen = () => {
    setActiveView(BookingView.AppointmentSelectionView);
  };

  if (isLoading || !hospitalInfo) {
    return (
      <div
        className="h-screen w-screen flex justify-center items-center background-gradient-booking"
        data-testid="transition-view-loading-container"
      >
        <Loading />
      </div>
    );
  }

  const summitviewTextStyles =
    subdomain === 'summitview'
      ? {
          color: '#2E2E2E',
          backgroundColor: '#FFFFFF',
        }
      : {};

  return (
    <div
      className="font-booking h-screen w-screen overflow-auto bg-center bg-cover px-8 py-6 lg:px-20 lg:py-8"
      style={{backgroundImage: `url(${hospitalInfo.backgroundImageURL})`}}
      onClick={navigateScreen}
      data-testid="transition-view-container"
    >
      {hospitalInfo.logoURL && (
        <img src={hospitalInfo.logoURL} className="h-20 lg:h-36" />
      )}

      <div className="mt-12 space-y-2">
        <p
          className="font-bold text-2xl lg:text-3xl inline-block px-3 py-2 rounded-md"
          style={summitviewTextStyles}
        >
          {hospitalInfo.title}
        </p>

        <p
          className="font-normal text-base lg:text-2xl inline-block px-3 py-2 rounded-md"
          style={summitviewTextStyles}
        >
          {hospitalInfo.description}
        </p>
      </div>
    </div>
  );
}

export default TransitionView;
